<script lang="ts">
  import { theme } from '$stores/theme.svelte';
  import Icon from '../icons/Icon.svelte';
</script>

<button
  class="icon-btn"
  type="button"
  onclick={() => theme.toggle()}
  aria-label={theme.current === 'modern' ? 'Switch to brutalist theme' : 'Switch to modern theme'}
  title={theme.current === 'modern' ? 'VU-MODERN active' : 'VU-BRUTALIST active'}
>
  {#if theme.current === 'modern'}
    <Icon name="sun" />
  {:else}
    <Icon name="square-grid" />
  {/if}
</button>

<style>
  .icon-btn {
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    background: var(--bg-card);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition:
      background var(--t),
      border-color var(--t),
      transform var(--t-fast),
      box-shadow var(--t);
  }
  .icon-btn:hover {
    background: var(--bg-card-hover);
    border-color: var(--border-2);
  }
  :global([data-theme='brutalist']) .icon-btn {
    border: 2px solid var(--text);
    box-shadow: 3px 3px 0 var(--text);
  }
  :global([data-theme='brutalist']) .icon-btn:hover {
    background: var(--accent-dim);
    transform: translate(-1px, -1px);
    box-shadow: 4px 4px 0 var(--text);
  }
  :global([data-theme='brutalist']) .icon-btn:active {
    transform: translate(2px, 2px);
    box-shadow: 1px 1px 0 var(--text);
  }
</style>
